enum DealLockReason {
  FUNNEL_LOCKED = "funnelLocked",
  STAGE_READ_ONLY = "stageReadOnly",
}

export default DealLockReason;
